<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name:'AppView',
  provide () {
    return {
      app: this
    }
  },
  data(){
    return {
      setting:null
    }
  },
  methods:{
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token') && this.$route.name != 'login'){
          this.$router.push({path:'/login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }
  },
  created(){
    this.getBaseInfo()
  }
}
</script>